interface TermsOfServiceProps {
  className?: string
}

const TermsOfService = ({ className = "" }: TermsOfServiceProps) => {
  const termsOfService = `MiraPASS 利用規約

本利用規約（以下「本規約」といいます）は、ミラッソ株式会社（以下「当社」といいます）が提供する教育支援サービス「MiraPASS」（以下「本サービス」といいます）の利用条件を定めるものです。本サービスをご利用いただくには、本規約およびプライバシーポリシーに同意していただく必要があります。

第1条（適用）
本規約は、本サービスの利用に関する一切の関係に適用されます。当社は、本規約のほか、個別の利用ルールやガイドラインを定める場合があります。これらは本規約の一部を構成します。

第2条（登録および解約）
本サービスの登録・解約は、原則として所属する学校を通じて行うものとします。個別での登録や解約が必要な場合は、当社が別途定める方法に従って行うものとします。

第3条（利用環境の整備）
利用者は、本サービスを利用するために必要な端末、通信環境等を自己の責任と負担で用意するものとします。通信費用は利用者の負担となります。

第4条（禁止事項）
利用者は、以下の行為をしてはなりません。
・法令または公序良俗に違反する行為
・他の利用者、学校、当社または第三者の権利を侵害する行為
・本サービスの運営を妨害する行為
・本サービスを商業目的で利用する行為（当社が認めた場合を除く）
・虚偽または不正な情報を登録する行為
・その他、当社が不適切と判断する行為

第5条（知的財産権）
1. 本サービスにおいて当社が提供する動画教材、AIコンテンツ、テキスト、画像、プログラムその他のコンテンツ（以下「コンテンツ」）に関する著作権、商標権、その他の知的財産権は、当社または正当な権利を有する第三者に帰属します。ただし、利用者が入力・提出した回答、文章、画像その他の成果物は、本項に定めるコンテンツには含まれません。
2. 利用者は、当社の事前の書面による承諾なく、以下の行為をしてはなりません。
 (1)コンテンツの複製、改変、翻案、公衆送信、頒布、貸与、譲渡、販売、出版、二次利用
 (2)コンテンツのダウンロード、スクリーンショット、録画、録音その他これに類する行為。ただし、当社がダウンロードを許可した教材、ワークシート等は、当社が示す利用条件および許可範囲に従ってダウンロードし、利用することができます。映像コンテンツのダウンロードは認めません。
 (3)コンテンツを第三者に提供または共有する行為（学校外の生徒、教職員、外部サイトへのアップロード等を含む）
本条に違反してコンテンツを使用した場合、当社は利用者に対し損害賠償を請求できるものとします。

第6条（AI機能の提供および所属学校の教職員による閲覧）
1.本サービスでは、利用者が実施したAIワーク(みらいワーク)、宿題、その他本サービス上で入力・提出した内容をもとに、AIが学習状況、良い点、課題、支援方針、興味・関心、強み、キャリアビジョン、活動・実績、成長等を要約・分析します。
2.前項の要約・分析結果は、所属学校の教職員が、生徒理解、授業運営、面談、探究活動、進路支援その他教育支援の参考情報として閲覧・活用できるものとします。
3.本サービスでは、利用者一人ひとりに応じたAIの問いかけ、フィードバック、学習支援を行うため、過去のAIワーク、宿題、振り返り、AIによる要約・分析結果等を参照する場合があります。
4.AIによる要約・分析結果は、教育支援のための参考情報であり、成績評価、人格評価、進路の判定その他これらに類する目的で利用されるものではありません。
5.AIによる出力内容には、不正確または不十分な内容が含まれる場合があります。利用者および所属学校は、必要に応じて内容を確認のうえ、本サービスを利用するものとします。

第7条（サービスの変更・停止）
当社は、事前の予告なく、本サービスの内容を変更・追加・廃止することができます。システム障害、保守点検等により本サービスを一時停止する場合があります。

第8条（免責事項）
当社は、本サービスが特定の目的に適合することを保証しません。当社は、利用者が本サービスを利用して被った損害について、当社の故意または重過失による場合を除き、一切の責任を負いません。

第9条（個人情報の取扱い）
当社は、別途定めるプライバシーポリシーに従い、利用者の個人情報を適切に取り扱います。

第10条（規約の変更）
当社は、必要に応じて本規約を変更できます。変更後の規約は、本サービス上に掲示した時点から効力を生じます。変更する場合は、変更する旨を本サービスの「お知らせ」に掲載して周知します。

第11条（準拠法・管轄）
本規約は日本法に準拠し、紛争が生じた場合は東京地方裁判所を第一審の専属的合意管轄裁判所とします。

附則
2025年9月1日 制定・施行
2026年10月4日 改定・施行

MiraPASS プライバシーポリシー

ミラッソ株式会社（以下「当社」）は、本サービスの利用者（以下「利用者」）の個人情報を、以下の方針に従い適切に管理します。

1. 取得する情報
当社は、本サービスの提供にあたり以下の情報を取得します。
・氏名、所属学校、学年、クラス
・利用履歴（視聴した動画、実施したAIワーク、宿題等の内容や回答）
・AIが生成するサマリ・分析結果・対話用メモ等の情報
・ログイン情報（メールアドレス、ID等）
・学校が提供する学習関連データ

2. 利用目的
取得した個人情報は、以下の目的で利用します。
・本サービスの提供、運営
・AIによる生徒の学習状況・サマリ・支援情報の可視化および所属学校の教職員への提供
・学習効果向上のための分析
・お知らせやサポート情報の提供
・不正利用の防止
なお、AIによる要約・分析結果は、成績評価、人格評価、進路の判定その他これらに類する目的で利用するものではなく、教育支援のための参考情報として利用します。

3. 所属学校への提供及び業務委託
当社は、利用者が所属する学校に対し、本サービスの提供、学習状況の可視化、生徒理解、授業運営、面談、探究活動、進路支援その他教育支援の目的で、利用者の動画視聴履歴、AIワーク・宿題・振り返り等をもとにAIが生成した要約・分析結果、支援方針等を提供することがあります。
当社は、本サービスの提供・運営に必要な範囲で、業務委託先に個人情報の取扱いを委託する場合があります。この場合、委託先に対して必要かつ適切な監督を行います。
当社は、所属学校への提供、上記の業務委託および法令に基づく場合を除き、個人情報を第三者に提供しません。

4. 個人情報の管理
当社は、個人情報への不正アクセス、漏えい、紛失を防止するため、適切なセキュリティ対策を講じます。

5. 個人情報の開示・訂正・削除
利用者または学校からの請求に基づき、当社は速やかに個人情報の開示・訂正・削除を行います。

6. 改定
当社は、必要に応じて本ポリシーを変更できます。変更後の本ポリシーは、本サービス上に掲示した時点から効力を生じます。変更する場合は、変更する旨を本サービスの「お知らせ」に掲載して周知します。

7. お問い合わせ窓口
ミラッソ株式会社 info@mirasso.co.jp

附則
2025年9月1日 制定・施行
2026年10月4日 改定・施行`

  return (
    <div className={`border border-gray-300 rounded-md h-64 overflow-y-auto bg-gray-50 p-4 ${className}`}>
      <pre className="text-xs text-gray-700 whitespace-pre-wrap font-sans leading-relaxed">
        {termsOfService}
      </pre>
    </div>
  )
}

export default TermsOfService